import { graphql } from "react-relay";
import { readInlineData } from "relay-runtime";

import { notEmpty } from "shared/lib/utils";

import type { helpersGetVideoYoutubeIdVideo$key } from "scmp-app/queries/__generated__/helpersGetVideoYoutubeIdVideo.graphql";

export const getVideoYoutubeId = (reference?: helpersGetVideoYoutubeIdVideo$key | null) => {
  const video = readInlineData(
    graphql`
      fragment helpersGetVideoYoutubeIdVideo on Video @inline {
        youtubeId
        videoSource {
          id
          type
        }
      }
    `,
    reference ?? null,
  );

  return (
    video?.youtubeId ??
    video?.videoSource?.find(source => source?.type === "youtube")?.id ??
    undefined
  );
};

export const getVideoYoutubeThumbnailUrl = (youtubeId?: string) => {
  if (!notEmpty(youtubeId)) return;

  const thumbnails = [
    `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
    `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`,
    `https://i.ytimg.com/vi/${youtubeId}/mqdefault.jpg`,
    `https://i.ytimg.com/vi/${youtubeId}/sddefault.jpg`,
  ];

  return thumbnails;
};
